import { IoMdTime } from "react-icons/io"
import HeaderLabel from "../headerLabel"
import { TimingSectionWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import Input from "@Common/input"
import CustomSelect from "@Common/CustomSelect"
import CustomButton from "@Common/CustomButton"
import EventIcon from "@assets/svg/EventIcon.svg?react"
import {
	IGetMasterDataEventTiming,
	IGetMasterDataEventType,
} from "src/services/Automations/GetMasterData/types"
import { useEffect, useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { IFormAutomationCentre } from "../.."
interface IProps {
	eventTimings: IGetMasterDataEventTiming[]
	listData: IGetMasterDataEventType[]
}

export default function TimingSection({ eventTimings, listData }: IProps) {
	/* ---------------------------------- Hooks --------------------------------- */
	const { t, i18n: { language } } = useTranslation()
	const { watch, resetField } = useFormContext<IFormAutomationCentre>()
	const eventTypeWatch = watch("eventType")
	const eventTimingWatch = watch("eventTiming")

	const eventTimingsList = useMemo(() => {
		const data = eventTimings?.map((item) => {
			return {
				value: item.id.toString(),
				label: language === "ar" ? item.description : item.descriptionEn,
			}
		})
		return data ?? []
	}, [eventTimings, language])

	
	const typeTime = useMemo(() => {
		const data = [
			{ label: t("Automation.Hours"), value: "1" },
			{ label: t("Automation.Days"), value: "2" },
			{ label: t("Automation.Minutes"), value: "3" },
		]
		return data ?? []
	}, [])

	useEffect(() => {
		if (eventTimingWatch === "3") {
			resetField("time")
			resetField("timeType")
		}
	}, [eventTimingWatch, resetField])

	return (
		<TimingSectionWrapper>
			<HeaderLabel
				icons={<IoMdTime />}
				label={t("AutomationCentre.timing")}
				tooltip='test'
			/>
			<div className='lastSection'>
				<p>{t("AutomationCentre.activate_this_action")}</p>
				<div className='containerTimingInputs'>
					<div>
						<CustomSelect
							data={eventTimingsList}
							name='eventTiming'
							withOutErrorMessage
							registerOptions={{
								required: {
									value: true,
									message: t("COMMON.REQUIRED"),
								},
							}}
						/>
					</div>
					{eventTimingWatch !== "3" && (
						<div className='middelContainer'>
							<div>
								<Input
									name='time'
									withOutErrorMessage
									type='number'
									registerOptions={{
										required: {
											value: true,
											message: t("COMMON.REQUIRED"),
										},
									}}
								/>
							</div>
							<div>
								<CustomSelect
									data={typeTime}
									name='timeType'
									withOutErrorMessage
									registerOptions={{
										required: {
											value: true,
											message: t("COMMON.REQUIRED"),
										},
									}}
								/>
							</div>
						</div>
					)}
					<div>
						<CustomButton
							label={
								language === "ar" 
									? listData.find((item) => item.id.toString() === eventTypeWatch)?.description
									: listData.find((item) => item.id.toString() === eventTypeWatch)?.descriptionEn
							}
							customBG='#EEEBFF'
							borderColor='#EEEBFF'
							customPadding='10px'
							borderRadius='8px'
							withIcone
							iconPosition='ltr'
							customIcon={<EventIcon />}
						/>
					</div>
				</div>
			</div>
		</TimingSectionWrapper>
	)
}
